
namespace RioERP.Masters {
    export class CurrenciesColumns {
        static columnsKey = 'Masters.Currencies';
    }
}